<template>
  <div>
    <LayoutPageHeader 
      title="Blog" 
      background-image="https://cdn-media.geekcafe.com/a0d4d17b-ec8f-4f28-9169-97e3e5bb4d37/person-looking-at-phone-and-at-macbook-pro-1181244_1920x400.jpg" 
    />

    <main class="archive">
      <div class="block html-block">
        <div class="container">
          <div class="d-flex justify-content-center align-items-center mb-4">
            <h2 class="text-center mb-0">Latest Articles</h2>
            <a href="/rss.xml" class="rss-link ml-3" title="Subscribe to RSS Feed" target="_blank">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M4 11a9 9 0 0 1 9 9" />
                <path d="M4 4a16 16 0 0 1 16 16" />
                <circle cx="5" cy="19" r="1" />
              </svg>
              RSS
            </a>
          </div>
          <!-- having a issue with this in production, just hangs the site-->
          <!-- <div class="row justify-content-center">
            <div class="col-md-8">
              <div class="input-group mb-5">
                <input v-model="searchQuery" type="text" class="form-control" placeholder="Search articles...">
              </div>
            </div>
          </div> -->
        </div>
      </div>
      <div class="container">
        <div class="row">
          <!-- Blog Posts Column -->
          <div class="col-lg-8">
            <div class="row">
              <div v-for="post in publishedPosts" :key="post._path" class="col-md-6 mb-4">
                <BlogCard :post="post" />
              </div>
            </div>
          </div>

          <!-- Sidebar Column -->
          <div class="col-lg-4">
            <BlogSidebar />
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script setup>
import { ref, computed, watch } from 'vue'

definePageMeta({
  layout: 'default',
  title: 'Blog'
})

const searchQuery = ref('')
const initialPosts = ref([])
const searchResults = ref([])
const isSearching = ref(false)

// Fetch initial posts from the custom API endpoint
const { data: fetchedPosts, pending: _pending, error: _error } = await useAsyncData(
  'blog-posts',
  () => $fetch('/api/blog/list')
);


if (fetchedPosts.value) {
  initialPosts.value = fetchedPosts.value;
}

// The posts to display are either the initial posts or the search results
const publishedPosts = computed(() => {
  return searchQuery.value ? searchResults.value : initialPosts.value;
});

// Debounced search with timeout tracking
let searchTimeout = null
const performSearch = async () => {
  if (searchQuery.value) {
    isSearching.value = true
    try {
      const results = await $fetch('/api/search', {
        method: 'POST',
        body: { query: searchQuery.value }
      });
      searchResults.value = results;
    } catch (error) {
      console.error('Search failed:', error)
      searchResults.value = []
    } finally {
      isSearching.value = false
    }
  } else {
    searchResults.value = []; // Clear results when query is empty
    isSearching.value = false
  }
};

// Watch with debouncing to prevent excessive API calls
watch(searchQuery, () => {
  if (searchTimeout) {
    clearTimeout(searchTimeout)
  }
  
  searchTimeout = setTimeout(() => {
    performSearch()
  }, 300) // 300ms debounce
});

</script>

<style scoped>
.archive {
  padding: 0 0 4rem 0;
}

.block.html-block {
  padding: 2rem 0;
}

.block.html-block h2 {
  font-size: 2.5rem;
  font-weight: 700;
  color: #333;
  margin: 0;
}

.rss-link {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  color: #ff6600;
  text-decoration: none;
  border: 2px solid #ff6600;
  border-radius: 6px;
  font-weight: 600;
  font-size: 0.9rem;
  transition: all 0.2s;
}

.rss-link:hover {
  background: #ff6600;
  color: white;
  text-decoration: none;
}

.rss-link svg {
  width: 20px;
  height: 20px;
}

.row {
  margin-left: -15px;
  margin-right: -15px;
}

.row > div {
  padding-left: 15px;
  padding-right: 15px;
}

.mb-4 {
  margin-bottom: 2rem;
}
</style>
